/**
 * Postcode validator — accepts UK and France today (iter71.5).
 *
 * - UK: 1-2 letters + digit + optional letter/digit, optional space,
 *   digit + 2 letters. e.g. ``SW1A 1AA`` / ``M1 1AE`` / ``B33 8TH``.
 * - FR: five digits. e.g. ``75001`` / ``13008``.
 *
 * The backend geocoder also infers the country from the postcode
 * shape, so these two formats stay in sync.
 */

const UK_RE = /^([A-Z]{1,2}\d[A-Z\d]?)\s*(\d[A-Z]{2})$/i;
const FR_RE = /^\d{5}$/;

export function detectPostcodeCountry(raw) {
  const pc = (raw || '').trim();
  if (!pc) return null;
  if (UK_RE.test(pc)) return 'UK';
  if (FR_RE.test(pc)) return 'FR';
  return null;
}

export function isValidPostcode(raw) {
  return detectPostcodeCountry(raw) !== null;
}

export function normalisePostcode(raw) {
  const pc = (raw || '').trim();
  if (!pc) return '';
  if (UK_RE.test(pc)) {
    const m = pc.toUpperCase().match(UK_RE);
    return `${m[1]} ${m[2]}`;
  }
  if (FR_RE.test(pc)) return pc;
  return pc.toUpperCase();
}
